import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { patchApi } from 'views/services/api';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';

const CancleReservation = ({ open, handleClose, data, fetch }) => {
  const params = useParams();
  const reservationId = params.id;

  // Handle cancel function
  const handleCheckIn = async () => {
    try {
      if (Array.isArray(data)) {
        // Multiple reservations
        for (const reservation of data) {
          try {
            let result = await patchApi(
              `api/reservation/cancle/${reservation._id}`,
              reservation
            );
            if (result.status === 200) {
              toast.success(
                `Reservation ${reservation?.roomNo || reservation._id} cancelled successfully`
              );
            } else {
              toast.error(
                result?.response?.data?.error ||
                `Failed to cancel reservation ${reservation?._id}`
              );
            }
          } catch (err) {
            console.error(err);
            toast.error(
              `Error while cancelling reservation ${reservation?._id}`
            );
          }
        }
      } else {
        // Single reservation
        let result = await patchApi(
          `api/reservation/cancle/${reservationId || data._id}`,
          data
        );
        if (result.status === 200) {
          toast.success('Reservation cancelled successfully');
        } else {
          toast.error(
            result?.response?.data?.error || 'Something went wrong'
          );
        }
      }

      // Refresh data & close modal
      await fetch();
      handleClose();
    } catch (error) {
      console.log(error);
      toast.error('Unexpected error occurred while cancelling');
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Cancel Reservation</DialogTitle>
      <DialogContent>
        <p>
          {Array.isArray(data)
            ? `Are you sure you want to cancel ${data.length} reservations?`
            : 'Are you sure you want to cancel this reservation?'}
        </p>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          No
        </Button>
        <Button onClick={handleCheckIn} variant="contained" color="error">
          Yes, Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CancleReservation.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  fetch: PropTypes.func.isRequired,
};

export default CancleReservation;
